function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { throttleToAnimationFrame } from './utils/utils';
import wixBgImageWrapper from './elements/wixBgImage/wixBgImage';
import wixBgMediaWrapper from './elements/wixBgMedia/wixBgMedia';
import wixDropdownMenuWrapper from './elements/wixDropdownMenu/wixDropdownMenu';
import wixElementWrapper from './elements/wixElement';
import wixIframeWrapper from './elements/wixIframe/wixIframe';
import wixImageWrapper from './elements/wixImage/wixImage';
import wixProGalleryWrapper from './elements/wixProGallery/wixProGallery';
import wixVideoWrapper from './elements/wixVideo/wixVideo';

function init(services) {
  require('./shims/native-shim');

  var resizeObserver = services.resizeService.init(function (entries) {
    var rootElements = resizeService.getLayoutTargets(entries.map(function (entry) {
      return entry.target;
    }));
    rootElements.forEach(function (e) {
      return e.reLayout();
    });
  });
  var windowResizeService = {
    registry: new Set(),
    observe: function observe(element) {
      windowResizeService.registry.add(element);
    },
    unobserve: function unobserve(element) {
      windowResizeService.registry["delete"](element);
    }
  };
  services.windowResizeService.init(throttleToAnimationFrame(function () {
    return windowResizeService.registry.forEach(function (element) {
      return element.reLayout();
    });
  }));
  var resizeService = {
    observedElementToRelayoutTarget: new Map(),
    getLayoutTargets: function getLayoutTargets(elements) {
      var elementsNeedRelayout = new Set();
      elements.forEach(function (e) {
        return elementsNeedRelayout.add(resizeService.observedElementToRelayoutTarget.get(e));
      });
      return elementsNeedRelayout;
    },
    observe: function observe(element) {
      resizeService.observedElementToRelayoutTarget.set(element, element);
      resizeObserver.observe(element);
    },
    unobserve: function unobserve(element) {
      resizeService.observedElementToRelayoutTarget["delete"](element);
      resizeObserver.unobserve(element);
    },
    observeChild: function observeChild(childElement, rootElement) {
      resizeService.observedElementToRelayoutTarget.set(childElement, rootElement);
      resizeObserver.observe(childElement);
    },
    unobserveChild: function unobserveChild(childElement) {
      resizeService.observedElementToRelayoutTarget["delete"](childElement);
      resizeObserver.unobserve(childElement);
    }
  };
  var WixElement = wixElementWrapper({
    resizeService: resizeService
  });
  defineCustomElement('wix-element', WixElement);
  return {
    defineWixImage: defineWixImage.bind(null, WixElement),
    defineWixBgImage: defineWixBgImage.bind(null, WixElement),
    defineWixBgMedia: defineWixBgMedia.bind(null, WixElement, windowResizeService),
    defineWixProGallery: defineWixProGallery.bind(null, WixElement),
    defineWixDropdownMenu: defineWixDropdownMenu.bind(null, WixElement),
    defineWixVideo: defineWixVideo.bind(null, WixElement),
    defineWixIframe: defineWixIframe.bind(null, WixElement)
  };
}

function defineCustomElement(elementName, elementClass) {
  if (customElements.get(elementName) === undefined) {
    customElements.define(elementName, elementClass);
  }
}

function defineWixImage(WixElement, externalServices, environmentConsts) {
  var WixImage = wixImageWrapper(WixElement, externalServices, environmentConsts);
  defineCustomElement('wix-image', WixImage);
}

function defineWixBgImage(WixElement, externalServices, environmentConsts) {
  var WixBgImage = wixBgImageWrapper(WixElement, externalServices, environmentConsts);
  defineCustomElement('wix-bg-image', WixBgImage);
}

function defineWixBgMedia(WixElement, windowResizeService, externalServices, environmentConsts) {
  var WixBgMedia = wixBgMediaWrapper(WixElement, _objectSpread({
    windowResizeService: windowResizeService
  }, externalServices), environmentConsts);
  defineCustomElement('wix-bg-media', WixBgMedia);
}

function defineWixProGallery(WixElement, externalServices) {
  var WixProGallery = wixProGalleryWrapper(WixElement, externalServices);
  defineCustomElement('wix-pro-gallery', WixProGallery);
}

function defineWixDropdownMenu(WixElement, externalServices) {
  var WixDropdownMenu = wixDropdownMenuWrapper(WixElement, externalServices);
  defineCustomElement('wix-dropdown-menu', WixDropdownMenu);
}

function defineWixVideo(WixElement, externalServices, environmentConsts) {
  var WixVideo = wixVideoWrapper(WixElement, externalServices, environmentConsts);
  defineCustomElement('wix-video', WixVideo);
}

function defineWixIframe(WixElement, externalServices) {
  var WixIframe = wixIframeWrapper(WixElement, externalServices);
  defineCustomElement('wix-iframe', WixIframe);
}

export default {
  init: init
};
//# sourceMappingURL=wixCustomElementsRegistry.js.map